// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leftBlock {
    width: 25%;
    background: var(--color-content-sidebar);
    height: 100vh;
    padding: 26px 30px;
}
.rightBlock {
    flex: 1 1;
    background: var(--color-content);
    height: 100vh;
    padding: 30px;
}

.mainWrapper {
    flex: 1 1;
    height: 100vh;
    display: flex;
    align-items: flex-start;
    overflow: auto;
}

.leftBlockTop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
}

.leftBlockList {
    width: 100%;

}

.leftBlockListItem {
    width: 100%;
    min-height: 64px;
    margin-bottom: 15px;
    padding: 20px;
    background: var(--color-content);
    border-radius: 5px;
    cursor: pointer;
    overflow: hidden;
    position: relative;
}

.addView {
    width: 44px;
    height: 44px;
    border-radius: 5px;
    background: var(--color-content-highlight);
    border: unset;
}

.addViewIcon {
    width: 24px;
    height: 24px;
}

.leftBlockListItemTop {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 5px;
}
.leftBlockListItemTitle {
    color: var(--color-icon-stroke);
    font-size: 18px;
}

.notification {
    width: 34px;
    height: 24px;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--color-notifiaction-background);
}

.notificationCount {
    color: #fff;
    font-weight: 700;
    font-size: 12px;
    margin-left: 3px;
}

.leftBlockListItemBottomCamera {
    width: 18px;
    height: 18px;
    margin-right: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.leftBlockListItemBottomCameraText {
    font-size: 14px;
    color: var(--color-highlighted-typography);
}
.leftBlockListItemBottom {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.activeLeftBlockListItem {
    box-shadow: 0px 5px 25px 0px var(--color-item-shadow);
}
.activeLeftBlockListItemBorder {
    width: 4px;
    height: 100%;
    background: var(--color-item-highlight);
    position: absolute;
    left: 0;
    top: 0;
}

.rightBlockTop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 35px;
}

.rightBlockTitle {
    font-weight: 700;
    font-size: 20px;
}
.rightBlockAddCameraBtn {
    width: auto;
    height: 34px;
    font-weight: 450;
    font-size: 14px;
    color: var(--color-addcamera-typography);
    background: var(--color-content-sidebar);
    border-radius: 5px;
    border: unset;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px ;
}

.toggle.react-toggle--checked .react-toggle-track {
    background-color: var(--color-item-highlight)
}

.toggle.react-toggle--checked .react-toggle-track:hover {
    background-color: var(--color-item-highlight) !important
}

.react-toggle-thumb {
    border: none;
}

.deleteButton {
    width: auto;
    height: 34px;
    font-weight: 450;
    font-size: 14px;
    color: var(--color-status-red);
    background: none;
    border: 1px solid var(--color-status-red);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px ;
}


.tabsMainWrapper {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 30px;
    margin-top: 20px;
}

.tabsWrapper {

    padding: 5px;
    background: var(--color-content-sidebar);
    border-radius: 5px;
    display: flex;
}

.tabsItem {
    display: flex;
    align-items: center;
    height: 34px;
    padding: 0 10px;
    margin-right: 5px;
    background: var(--color-content);
    border-radius: 5px;
    cursor: pointer;
}

.tabsItemText {
    color: var(--color-sidebar-typography-disabled);
    font-size: 14px;
    margin-left: 4px;
}

.activeTab {
    background: var(--color-content-highlight);
}

.activeTab .tabsItemText {
    color: var(--color-content);
}
.activeViewTabWrapper {
    width: 100%;
    /*display: flex;*/
    /*flex-wrap: wrap;*/
    /*justify-content: space-between;*/
}

.viewTabItem {
    width: 320px;
    height: 180px;
    max-width: 100%;
    border-radius: 10px;
    /*overflow: hidden;*/
    /*margin-bottom: 31px;*/
    transition: .5s;
    position: relative;
    float: left;
    padding: 5px;
}

.viewTabItemImgWrapper {
    width: 100%;
    /*height: 180px;*/
    height: 100%;
    cursor: pointer;
    border-radius: 10px;
    z-index: 1;
    display: flex;
}
.viewTabItemImg {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    object-fit: cover;
}
.viewTabItemBottom {
    width: 100%;
    height: 54px;
    background: var(--color-content-sidebar);
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 15px;
    border-radius: 0 0 10px 10px;
}

.viewTabItemBottomLeft {
    display: flex;
    align-items: center;
}

.viewTabItemBottomRightDots {
    border: unset;
    background: unset;
}

.cameraStatus {
    width: 5px;
    height: 5px;
    border-radius: 100%;
}

.viewTabItemBottomLeftTitle {
    color: var(--color-content);
    font-size: 16px;
    margin-left: 5px;
    transition: .5s;
    text-shadow: 0px 0px 20px rgb(237 237 237);
}

.activeApartmentTabWrapper {
    width: 100%;
}

.activeApartmentTabTop {
    width: 100%;
    min-height: 200px;
    border: 1px solid var(--color-input-border);
    border-radius: 5px 5px 0 0;
}
.activeApartmentTabBottom {
    width: 100%;
    height: 63px;
    background: var(--color-content-sidebar);
    border-radius:  0 0 5px 5px;
}

.viewTabItemHoverBlock{
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    /*padding-bottom: 54px;*/
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: .5s;
    overflow: hidden;
    margin: 5px;
    border-radius: 10px;
}

.viewTabItemHoverBlockRound {
    width: 103px;
    height: 54px;
    border-radius: 50px;
    background: var(--color-content);
    display: flex;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
    justify-content: space-between;
    position: relative;
}

.viewTabItemHoverBlockLeft {
    cursor: pointer;
}

.viewTabItemHoverBlockRight {
    cursor: pointer;
}

.viewTabItemImgWrapper:hover .viewTabItemHoverBlock {
    /*width: 100%;*/
    opacity: 1;
    overflow: visible!important;
    object-fit: cover;
}

.viewTabItemHoverMoreActions {
    width: 163px;
    background: var(--color-content);
    position: absolute;
    bottom: -50px;
    right: -100px;
    border-radius: 5px;
    box-shadow: 0px 5px 25px 0px var(--color-item-shadow);
    border: 1px solid var(--color-input-border);
    transition: .5s;
}

.viewTabItemHoverMoreActionsItem {
    width: 163px;
    height: 53px;
    display: flex;
    /*justify-content: center;*/
    align-items: center;
    padding-left: 20px;
}

.viewTabItemHoverMoreActionsItemText{
    color: var(--color-icon-stroke);
    font-size: 14px;
    margin-left: 7px;
}

.borderBottom {
    border-bottom: 1px solid var(--color-input-border)
}

/*.viewTabItemHoverBlockRound:hover .viewTabItemHoverMoreActions{*/
/*    display: block!important;*/
/*}*/


.addCameraPopupWrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top:0;
    left: 0;
    background: rgba(0, 0, 0, 0.48);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 999;
}

.addCameraPopupContent {
    width: 100%;
    max-width: 824px;
    background: var(--color-content);
    min-height: 300px;
    border-radius: 5px;
}

.addScenarioPopupContent {
    width: 100%;
    max-width: 824px;
    background: var(--color-content);
    border-radius: 5px;
    overflow: hidden;
}

.addViewPopupContent {
    width: 100%;
    max-width: 824px;
    background: var(--color-content-sidebar);
    /*min-height: 300px;*/
    border-radius: 5px;
    max-height: 90vh;
    top: 100px;
}

.addCameraPopupHeader {
    width: 100%;
    height: 44px;
    background: var(--color-sidebar);
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.addCameraPopupHeaderLeft {

}
.addCameraPopupHeaderRight {
    cursor: pointer;
}
.addCameraPopupHeaderLeftText {
    color: var(--color-popup-header);
    font-size: 14px;
    margin-left: 10px;
}

.addCameraPopupTabsWrapper {
    width: 100%;
    height: 74px;
    background: var(--color-content-sidebar);
    display: flex;
    align-items: center;
    padding: 0 20px;
}
.addCameraPopupTab {
    height: 34px;
    border-radius: 50px;
    font-size: 14px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--color-content);
    border: 1px solid var(--color-camera-popup);
    padding: 0 15px;
    cursor: pointer;

}

.activeCameraPopupTab {
    border: 1px solid var(--color-content-highlight)!important;
    background: var(--color-content-highlight);
    color: var(--color-content);
}

.selectCameraWrapper {

}

.selectCameraWrapperBody {
    width: 100%;
    min-height: 200px;
    background: var(--color-popup-content);
    padding: 20px;
    overflow-y: scroll;
    max-height: 60vh;
}
.selectCameraWrapperFooter {
    width: 100%;
    height: 74px;
    background: var(--color-content-sidebar);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
}


.selectCameraWrapperFooterLeft {
    color: var(--color-icon-stroke);
    font-size: 14px;
    text-decoration: underline;
    cursor: pointer;
}

.selectCameraWrapperFooterRight {
    padding: 0 10px;
    height: 34px;
    background: var(--color-content-highlight);
    font-size: 14px;
    color: var(--color-sidebar-typography-active);
    border-radius: 5px;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.saveNewView {
    padding: 0 10px;
    height: 34px;
    background: #0095FF;
    font-size: 14px;
    color: white;
    border-radius: 5px;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.cancelSaveNewView {
    padding: 0 10px;
    height: 34px;
    /*background: #0095FF;*/
    font-size: 14px;
    color: #0095FF;
    border-radius: 5px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border: 1px solid #0095FF;
    margin-right: 15px;

}


.searchInputWrapper {
    width: 100%;
    position: relative;
    margin-bottom: 30px;
}

.searchInputWrapper input{
    width: 100%;
    height: 44px;
    border: 1px solid var(--color-input-border);
    background-color: var(--color-content);
    border-radius: 5px;
    padding-left: 10px;
    padding-right: 0;
}

.searchInputWrapper button{
   background: unset;
    border: unset;
    position: absolute;
    right: 5px;
    top: 5px;
    padding: 0;
}

.camerasListWrapper {
    width: 100%;
    flex: 1 1;
    height: auto;
    overflow: auto;
}


.camerasListChooseAll {
    width: 100%;
    padding: 0 20px;
    margin-bottom: 20px;
}
.camerasListChooseAll label {
    display: flex;
    align-items: center;
}

.camerasListChooseAll label input{
    margin-right: 10px;
    width: 18px;
    height: 18px;
}

.camerasList {
    width: 100%;
}


.camerasListItem {
    width: 100%;
    height: 64px;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    border: 1px solid var(--color-input-border);
    border-radius: 5px;
    margin-bottom: 10px;
}

.camerasListItemLeft {
    display: flex;
    align-items: center;
}

.camerasListItemLeft input {
    margin-right: 10px;
    width: 18px;
    height: 18px;
}
.camerasListItemLeft svg {

}

.camerasListItemCameraId {
    margin-left: 5px;
    color: var(--color-icon-stroke);
    font-size: 14px;
}
.camerasListItemCameraName {
    margin-left: 10px;
    color: var(--color-icon-stroke);
    font-size: 14px;
}

.camerasListItemRight button {
    background: unset;
    border: unset;
    padding: unset;
}


.createNewCameraBody {
    width: 100%;
    min-height: 200px;
    overflow-y: auto;
    max-height: 90vh;
    background: var(--color-popup-content);
    padding: 20px;
}

.createNewScenarioBody {
    width: 100%;
    background: var(--color-popup-content);
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
}

.createNewViewBody {
    width: 100%;
    /*min-height: 200px;*/
    background: var(--color-content-sidebar);
    padding: 20px;
    padding-bottom: 0;
}

.createNewCameraFooter {
    width: 100%;
    height: 74px;
    background: var(--color-content-sidebar);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
}

.createNewViewFooter {
    width: 100%;
    /*height: 74px;*/
    /*background: #F5F5FA;*/
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 20px;
    padding-bottom: 20px;
}

.createNewCameraBodyTitle {
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 15px;
    display: block;
}

.inputWrapper {
    width: 100%;
    margin-bottom: 10px;
}
.inputWrapper label{
    display: block;
    color: var(--color-icon-stroke);
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.inputViewWrapper input {
    height: 44px;
    outline: none;
    background: var(--color-content);
}

.inputViewWrapper input:focus {
    outline: none;
}

.helpIcon {
    margin-left: 5px;
    cursor: pointer;
}

.labelWrapper {
    display: flex;
    align-items: center;
}

.cameraNameWrapper {
    opacity: 0;
    position: absolute;
    bottom: 15px;
    left: 15px;
    display: flex;
    align-items: center;
}

.viewTabItem:hover .cameraNameWrapper {
    opacity: 1;
}

.popup-input {
    color: var(--color-main-typography);
    background: var(--color-content);
    outline: none;
    width: 100%;
    height: 38px;
    border: 1px solid var(--color-input-border);
    border-radius: 5px;
    padding: 0 15px;
    font-size: 14px;
    margin-top: 5px;
}

.popup-input:focus {
    outline: none;
}

.menu-tabs-container {
    padding: 10px 20px;
    background-color: var(--color-popup-content);
}

.content-container {
    padding: 0;
}

.view-heading {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
}

.error-input {
    border: 1px solid var(--color-error-input-border);
    background-color: var(--color-error-input-background);
}

.canvas {
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 9;
    border: 1px solid var(--color-input-border);
}
polygon {
    stoke-weight: 1;
    fill: rgba(46, 204, 113, .2);
    stroke: black;
}

.exclusive-polygon {
    fill: rgba(208, 0, 0, .2);
}

@media screen and (max-width: 1000px) {
    .mainWrapper {
        width: 100%;
    }

    .rightBlock {
        background: var(--color-content);
        height: 100vh;
        padding: 30px;
        width: 100%;
        padding: 0;
    }
    .content-container {
        padding: 30px;
    }

    .content-heading-container {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }

    .content-heading {
        margin-bottom: 40px;
        font-weight: 700;
        font-size: 20px;
    }

    .content-sidebar-control {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .tab-content-container-image {
        width: 100%
    }

    .viewTabItem {
        width: 100%;
        aspect-ratio: 16 / 9;
        border-radius: 10px;
        /*overflow: hidden;*/
        /*margin-bottom: 31px;*/
        transition: .5s;
        position: relative;
        float: left;
        padding: 5px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/view.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,wCAAwC;IACxC,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,SAAO;IACP,gCAAgC;IAChC,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;IACI,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,0CAA0C;AAC9C;AACA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;IACI,qDAAqD;AACzD;AACA;IACI,UAAU;IACV,YAAY;IACZ,uCAAuC;IACvC,kBAAkB;IAClB,OAAO;IACP,MAAM;AACV;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,wCAAwC;IACxC,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;IAChB,yCAAyC;IACzC,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;;AAGA;IACI,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,2CAA2C;IAC3C,0BAA0B;AAC9B;AACA;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,wBAAwB;IACxB,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,qDAAqD;IACrD,2CAA2C;IAC3C,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA,kEAAkE;AAClE,gCAAgC;AAChC,IAAI;;;AAGJ;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,KAAK;IACL,OAAO;IACP,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gCAAgC;IAChC,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,wCAAwC;IACxC,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;;AAEA;AACA;IACI,eAAe;AACnB;AACA;IACI,gCAAgC;IAChC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gCAAgC;IAChC,2CAA2C;IAC3C,eAAe;IACf,eAAe;;AAEnB;;AAEA;IACI,0DAA0D;IAC1D,0CAA0C;IAC1C,2BAA2B;AAC/B;;AAEA;;AAEA;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,sCAAsC;IACtC,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;;AAGA;IACI,+BAA+B;IAC/B,eAAe;IACf,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,0CAA0C;IAC1C,eAAe;IACf,6CAA6C;IAC7C,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;;AAEtB;;;AAGA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,sCAAsC;IACtC,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;GACG,iBAAiB;IAChB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,WAAW;IACX,SAAO;IACP,YAAY;IACZ,cAAc;AAClB;;;AAGA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,2CAA2C;IAC3C,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;;AAEA;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,cAAc;AAClB;;;AAGA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,sCAAsC;IACtC,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,sCAAsC;IACtC,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,wCAAwC;IACxC,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mCAAmC;IACnC,gCAAgC;IAChC,aAAa;IACb,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,iDAAiD;IACjD,qDAAqD;AACzD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,2CAA2C;AAC/C;AACA;IACI,eAAe;IACf,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,gCAAgC;QAChC,aAAa;QACb,aAAa;QACb,WAAW;QACX,UAAU;IACd;IACA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,oBAAoB;QACpB,mBAAmB;QACnB,oBAAoB;QACpB,uBAAuB;QACvB,eAAe;QACf,kBAAkB;QAClB,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".leftBlock {\n    width: 25%;\n    background: var(--color-content-sidebar);\n    height: 100vh;\n    padding: 26px 30px;\n}\n.rightBlock {\n    flex: 1;\n    background: var(--color-content);\n    height: 100vh;\n    padding: 30px;\n}\n\n.mainWrapper {\n    flex: 1;\n    height: 100vh;\n    display: flex;\n    align-items: flex-start;\n    overflow: auto;\n}\n\n.leftBlockTop {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 40px;\n}\n\n.leftBlockList {\n    width: 100%;\n\n}\n\n.leftBlockListItem {\n    width: 100%;\n    min-height: 64px;\n    margin-bottom: 15px;\n    padding: 20px;\n    background: var(--color-content);\n    border-radius: 5px;\n    cursor: pointer;\n    overflow: hidden;\n    position: relative;\n}\n\n.addView {\n    width: 44px;\n    height: 44px;\n    border-radius: 5px;\n    background: var(--color-content-highlight);\n    border: unset;\n}\n\n.addViewIcon {\n    width: 24px;\n    height: 24px;\n}\n\n.leftBlockListItemTop {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    margin-bottom: 5px;\n}\n.leftBlockListItemTitle {\n    color: var(--color-icon-stroke);\n    font-size: 18px;\n}\n\n.notification {\n    width: 34px;\n    height: 24px;\n    border-radius: 3px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: var(--color-notifiaction-background);\n}\n\n.notificationCount {\n    color: #fff;\n    font-weight: 700;\n    font-size: 12px;\n    margin-left: 3px;\n}\n\n.leftBlockListItemBottomCamera {\n    width: 18px;\n    height: 18px;\n    margin-right: 5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.leftBlockListItemBottomCameraText {\n    font-size: 14px;\n    color: var(--color-highlighted-typography);\n}\n.leftBlockListItemBottom {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n}\n.activeLeftBlockListItem {\n    box-shadow: 0px 5px 25px 0px var(--color-item-shadow);\n}\n.activeLeftBlockListItemBorder {\n    width: 4px;\n    height: 100%;\n    background: var(--color-item-highlight);\n    position: absolute;\n    left: 0;\n    top: 0;\n}\n\n.rightBlockTop {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 35px;\n}\n\n.rightBlockTitle {\n    font-weight: 700;\n    font-size: 20px;\n}\n.rightBlockAddCameraBtn {\n    width: auto;\n    height: 34px;\n    font-weight: 450;\n    font-size: 14px;\n    color: var(--color-addcamera-typography);\n    background: var(--color-content-sidebar);\n    border-radius: 5px;\n    border: unset;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0 10px ;\n}\n\n.toggle.react-toggle--checked .react-toggle-track {\n    background-color: var(--color-item-highlight)\n}\n\n.toggle.react-toggle--checked .react-toggle-track:hover {\n    background-color: var(--color-item-highlight) !important\n}\n\n.react-toggle-thumb {\n    border: none;\n}\n\n.deleteButton {\n    width: auto;\n    height: 34px;\n    font-weight: 450;\n    font-size: 14px;\n    color: var(--color-status-red);\n    background: none;\n    border: 1px solid var(--color-status-red);\n    border-radius: 5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0 10px ;\n}\n\n\n.tabsMainWrapper {\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    margin-bottom: 30px;\n    margin-top: 20px;\n}\n\n.tabsWrapper {\n\n    padding: 5px;\n    background: var(--color-content-sidebar);\n    border-radius: 5px;\n    display: flex;\n}\n\n.tabsItem {\n    display: flex;\n    align-items: center;\n    height: 34px;\n    padding: 0 10px;\n    margin-right: 5px;\n    background: var(--color-content);\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.tabsItemText {\n    color: var(--color-sidebar-typography-disabled);\n    font-size: 14px;\n    margin-left: 4px;\n}\n\n.activeTab {\n    background: var(--color-content-highlight);\n}\n\n.activeTab .tabsItemText {\n    color: var(--color-content);\n}\n.activeViewTabWrapper {\n    width: 100%;\n    /*display: flex;*/\n    /*flex-wrap: wrap;*/\n    /*justify-content: space-between;*/\n}\n\n.viewTabItem {\n    width: 320px;\n    height: 180px;\n    max-width: 100%;\n    border-radius: 10px;\n    /*overflow: hidden;*/\n    /*margin-bottom: 31px;*/\n    transition: .5s;\n    position: relative;\n    float: left;\n    padding: 5px;\n}\n\n.viewTabItemImgWrapper {\n    width: 100%;\n    /*height: 180px;*/\n    height: 100%;\n    cursor: pointer;\n    border-radius: 10px;\n    z-index: 1;\n    display: flex;\n}\n.viewTabItemImg {\n    width: 100%;\n    height: 100%;\n    border-radius: 10px;\n    object-fit: cover;\n}\n.viewTabItemBottom {\n    width: 100%;\n    height: 54px;\n    background: var(--color-content-sidebar);\n    padding: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-left: 15px;\n    border-radius: 0 0 10px 10px;\n}\n\n.viewTabItemBottomLeft {\n    display: flex;\n    align-items: center;\n}\n\n.viewTabItemBottomRightDots {\n    border: unset;\n    background: unset;\n}\n\n.cameraStatus {\n    width: 5px;\n    height: 5px;\n    border-radius: 100%;\n}\n\n.viewTabItemBottomLeftTitle {\n    color: var(--color-content);\n    font-size: 16px;\n    margin-left: 5px;\n    transition: .5s;\n    text-shadow: 0px 0px 20px rgb(237 237 237);\n}\n\n.activeApartmentTabWrapper {\n    width: 100%;\n}\n\n.activeApartmentTabTop {\n    width: 100%;\n    min-height: 200px;\n    border: 1px solid var(--color-input-border);\n    border-radius: 5px 5px 0 0;\n}\n.activeApartmentTabBottom {\n    width: 100%;\n    height: 63px;\n    background: var(--color-content-sidebar);\n    border-radius:  0 0 5px 5px;\n}\n\n.viewTabItemHoverBlock{\n    opacity: 0;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    /*padding-bottom: 54px;*/\n    box-sizing: border-box;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: .5s;\n    overflow: hidden;\n    margin: 5px;\n    border-radius: 10px;\n}\n\n.viewTabItemHoverBlockRound {\n    width: 103px;\n    height: 54px;\n    border-radius: 50px;\n    background: var(--color-content);\n    display: flex;\n    align-items: center;\n    padding: 0 20px;\n    box-sizing: border-box;\n    justify-content: space-between;\n    position: relative;\n}\n\n.viewTabItemHoverBlockLeft {\n    cursor: pointer;\n}\n\n.viewTabItemHoverBlockRight {\n    cursor: pointer;\n}\n\n.viewTabItemImgWrapper:hover .viewTabItemHoverBlock {\n    /*width: 100%;*/\n    opacity: 1;\n    overflow: visible!important;\n    object-fit: cover;\n}\n\n.viewTabItemHoverMoreActions {\n    width: 163px;\n    background: var(--color-content);\n    position: absolute;\n    bottom: -50px;\n    right: -100px;\n    border-radius: 5px;\n    box-shadow: 0px 5px 25px 0px var(--color-item-shadow);\n    border: 1px solid var(--color-input-border);\n    transition: .5s;\n}\n\n.viewTabItemHoverMoreActionsItem {\n    width: 163px;\n    height: 53px;\n    display: flex;\n    /*justify-content: center;*/\n    align-items: center;\n    padding-left: 20px;\n}\n\n.viewTabItemHoverMoreActionsItemText{\n    color: var(--color-icon-stroke);\n    font-size: 14px;\n    margin-left: 7px;\n}\n\n.borderBottom {\n    border-bottom: 1px solid var(--color-input-border)\n}\n\n/*.viewTabItemHoverBlockRound:hover .viewTabItemHoverMoreActions{*/\n/*    display: block!important;*/\n/*}*/\n\n\n.addCameraPopupWrapper {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top:0;\n    left: 0;\n    background: rgba(0, 0, 0, 0.48);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    z-index: 999;\n}\n\n.addCameraPopupContent {\n    width: 100%;\n    max-width: 824px;\n    background: var(--color-content);\n    min-height: 300px;\n    border-radius: 5px;\n}\n\n.addScenarioPopupContent {\n    width: 100%;\n    max-width: 824px;\n    background: var(--color-content);\n    border-radius: 5px;\n    overflow: hidden;\n}\n\n.addViewPopupContent {\n    width: 100%;\n    max-width: 824px;\n    background: var(--color-content-sidebar);\n    /*min-height: 300px;*/\n    border-radius: 5px;\n    max-height: 90vh;\n    top: 100px;\n}\n\n.addCameraPopupHeader {\n    width: 100%;\n    height: 44px;\n    background: var(--color-sidebar);\n    padding: 0 15px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.addCameraPopupHeaderLeft {\n\n}\n.addCameraPopupHeaderRight {\n    cursor: pointer;\n}\n.addCameraPopupHeaderLeftText {\n    color: var(--color-popup-header);\n    font-size: 14px;\n    margin-left: 10px;\n}\n\n.addCameraPopupTabsWrapper {\n    width: 100%;\n    height: 74px;\n    background: var(--color-content-sidebar);\n    display: flex;\n    align-items: center;\n    padding: 0 20px;\n}\n.addCameraPopupTab {\n    height: 34px;\n    border-radius: 50px;\n    font-size: 14px;\n    margin-right: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: var(--color-content);\n    border: 1px solid var(--color-camera-popup);\n    padding: 0 15px;\n    cursor: pointer;\n\n}\n\n.activeCameraPopupTab {\n    border: 1px solid var(--color-content-highlight)!important;\n    background: var(--color-content-highlight);\n    color: var(--color-content);\n}\n\n.selectCameraWrapper {\n\n}\n\n.selectCameraWrapperBody {\n    width: 100%;\n    min-height: 200px;\n    background: var(--color-popup-content);\n    padding: 20px;\n    overflow-y: scroll;\n    max-height: 60vh;\n}\n.selectCameraWrapperFooter {\n    width: 100%;\n    height: 74px;\n    background: var(--color-content-sidebar);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 20px;\n}\n\n\n.selectCameraWrapperFooterLeft {\n    color: var(--color-icon-stroke);\n    font-size: 14px;\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.selectCameraWrapperFooterRight {\n    padding: 0 10px;\n    height: 34px;\n    background: var(--color-content-highlight);\n    font-size: 14px;\n    color: var(--color-sidebar-typography-active);\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.saveNewView {\n    padding: 0 10px;\n    height: 34px;\n    background: #0095FF;\n    font-size: 14px;\n    color: white;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.cancelSaveNewView {\n    padding: 0 10px;\n    height: 34px;\n    /*background: #0095FF;*/\n    font-size: 14px;\n    color: #0095FF;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    border: 1px solid #0095FF;\n    margin-right: 15px;\n\n}\n\n\n.searchInputWrapper {\n    width: 100%;\n    position: relative;\n    margin-bottom: 30px;\n}\n\n.searchInputWrapper input{\n    width: 100%;\n    height: 44px;\n    border: 1px solid var(--color-input-border);\n    background-color: var(--color-content);\n    border-radius: 5px;\n    padding-left: 10px;\n    padding-right: 0;\n}\n\n.searchInputWrapper button{\n   background: unset;\n    border: unset;\n    position: absolute;\n    right: 5px;\n    top: 5px;\n    padding: 0;\n}\n\n.camerasListWrapper {\n    width: 100%;\n    flex: 1;\n    height: auto;\n    overflow: auto;\n}\n\n\n.camerasListChooseAll {\n    width: 100%;\n    padding: 0 20px;\n    margin-bottom: 20px;\n}\n.camerasListChooseAll label {\n    display: flex;\n    align-items: center;\n}\n\n.camerasListChooseAll label input{\n    margin-right: 10px;\n    width: 18px;\n    height: 18px;\n}\n\n.camerasList {\n    width: 100%;\n}\n\n\n.camerasListItem {\n    width: 100%;\n    height: 64px;\n    padding: 20px;\n    display: flex;\n    justify-content: space-between;\n    border: 1px solid var(--color-input-border);\n    border-radius: 5px;\n    margin-bottom: 10px;\n}\n\n.camerasListItemLeft {\n    display: flex;\n    align-items: center;\n}\n\n.camerasListItemLeft input {\n    margin-right: 10px;\n    width: 18px;\n    height: 18px;\n}\n.camerasListItemLeft svg {\n\n}\n\n.camerasListItemCameraId {\n    margin-left: 5px;\n    color: var(--color-icon-stroke);\n    font-size: 14px;\n}\n.camerasListItemCameraName {\n    margin-left: 10px;\n    color: var(--color-icon-stroke);\n    font-size: 14px;\n}\n\n.camerasListItemRight button {\n    background: unset;\n    border: unset;\n    padding: unset;\n}\n\n\n.createNewCameraBody {\n    width: 100%;\n    min-height: 200px;\n    overflow-y: auto;\n    max-height: 90vh;\n    background: var(--color-popup-content);\n    padding: 20px;\n}\n\n.createNewScenarioBody {\n    width: 100%;\n    background: var(--color-popup-content);\n    padding: 20px;\n    max-height: 70vh;\n    overflow-y: auto;\n}\n\n.createNewViewBody {\n    width: 100%;\n    /*min-height: 200px;*/\n    background: var(--color-content-sidebar);\n    padding: 20px;\n    padding-bottom: 0;\n}\n\n.createNewCameraFooter {\n    width: 100%;\n    height: 74px;\n    background: var(--color-content-sidebar);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 20px;\n}\n\n.createNewViewFooter {\n    width: 100%;\n    /*height: 74px;*/\n    /*background: #F5F5FA;*/\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 0 20px;\n    padding-bottom: 20px;\n}\n\n.createNewCameraBodyTitle {\n    font-weight: 700;\n    font-size: 16px;\n    margin-bottom: 15px;\n    display: block;\n}\n\n.inputWrapper {\n    width: 100%;\n    margin-bottom: 10px;\n}\n.inputWrapper label{\n    display: block;\n    color: var(--color-icon-stroke);\n    font-size: 14px;\n    font-weight: 400;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.inputViewWrapper input {\n    height: 44px;\n    outline: none;\n    background: var(--color-content);\n}\n\n.inputViewWrapper input:focus {\n    outline: none;\n}\n\n.helpIcon {\n    margin-left: 5px;\n    cursor: pointer;\n}\n\n.labelWrapper {\n    display: flex;\n    align-items: center;\n}\n\n.cameraNameWrapper {\n    opacity: 0;\n    position: absolute;\n    bottom: 15px;\n    left: 15px;\n    display: flex;\n    align-items: center;\n}\n\n.viewTabItem:hover .cameraNameWrapper {\n    opacity: 1;\n}\n\n.popup-input {\n    color: var(--color-main-typography);\n    background: var(--color-content);\n    outline: none;\n    width: 100%;\n    height: 38px;\n    border: 1px solid var(--color-input-border);\n    border-radius: 5px;\n    padding: 0 15px;\n    font-size: 14px;\n    margin-top: 5px;\n}\n\n.popup-input:focus {\n    outline: none;\n}\n\n.menu-tabs-container {\n    padding: 10px 20px;\n    background-color: var(--color-popup-content);\n}\n\n.content-container {\n    padding: 0;\n}\n\n.view-heading {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n.error-input {\n    border: 1px solid var(--color-error-input-border);\n    background-color: var(--color-error-input-background);\n}\n\n.canvas {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 16 / 9;\n    border: 1px solid var(--color-input-border);\n}\npolygon {\n    stoke-weight: 1;\n    fill: rgba(46, 204, 113, .2);\n    stroke: black;\n}\n\n.exclusive-polygon {\n    fill: rgba(208, 0, 0, .2);\n}\n\n@media screen and (max-width: 1000px) {\n    .mainWrapper {\n        width: 100%;\n    }\n\n    .rightBlock {\n        background: var(--color-content);\n        height: 100vh;\n        padding: 30px;\n        width: 100%;\n        padding: 0;\n    }\n    .content-container {\n        padding: 30px;\n    }\n\n    .content-heading-container {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .content-heading {\n        margin-bottom: 40px;\n        font-weight: 700;\n        font-size: 20px;\n    }\n\n    .content-sidebar-control {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .tab-content-container-image {\n        width: 100%\n    }\n\n    .viewTabItem {\n        width: 100%;\n        aspect-ratio: 16 / 9;\n        border-radius: 10px;\n        /*overflow: hidden;*/\n        /*margin-bottom: 31px;*/\n        transition: .5s;\n        position: relative;\n        float: left;\n        padding: 5px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
